// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star-rating ion-icon {
  font-size: 2rem;
  margin: 10px;
  color: #cfd8dc;
  cursor: pointer;
}
.star-rating ion-icon.active {
  color: #ff9800;
}

.field-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.field-start {
  margin-left: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.form-review {
  margin-top: 20px;
}

.invitation-link {
  padding: 60px 24px;
}

.user-info {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: transparent;
  margin-right: 10px;
}

.img-user {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.user-name {
  display: flex;
  align-items: center;
}

.user-info-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.public-info {
  color: #808080;
  margin-left: 6px;
  margin-bottom: 4px;
}

.user-info-text {
  display: flex;
  flex-direction: column;
}

.custom-textarea {
  border: 1px solid #ccc;
  margin: 10px;
  padding: 8px;
  min-height: 90px;
}

.container-textarea {
  margin: 0px 40px 40px 40px;
}

.info-icon {
  margin-left: 5px;
  color: #4285f4;
  cursor: pointer;
}

ion-checkbox {
  --size: 18px;
  --checkbox-background-checked: #4285f4;
  margin-left: 3px;
}

ion-checkbox::part(container) {
  border-radius: 6px;
  border: 2px solid #4285f4;
}

.anonymous-label {
  padding-bottom: 2px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-left: 6px;
}

.icon-link ion-icon {
  margin-left: 4px;
  font-size: 22px;
}

ion-input {
  max-width: 65%;
}

.input-link {
  max-width: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/experiences/experience-review/experience-review.page.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,YAAA;EACA,sCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,eAAA;AAFF","sourcesContent":[".star-rating {\r\n  ion-icon {\r\n    font-size: 2rem;\r\n    margin: 10px;\r\n    color: #cfd8dc;\r\n    cursor: pointer;\r\n  }\r\n\r\n  ion-icon.active {\r\n    color: #ff9800;\r\n  }\r\n}\r\n\r\n.field-center {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.field-start {\r\n  margin-left: 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.form-review {\r\n  margin-top: 20px;\r\n}\r\n\r\n.invitation-link {\r\n  padding: 60px 24px;\r\n}\r\n\r\n.user-info {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n  background-color: transparent;\r\n  margin-right: 10px;\r\n}\r\n\r\n.img-user {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.user-name {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.user-info-container {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.public-info {\r\n  color: #808080;\r\n  margin-left: 6px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.user-info-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.custom-textarea {\r\n  border: 1px solid #ccc;\r\n  margin: 10px;\r\n  padding: 8px;\r\n  min-height: 90px;\r\n}\r\n\r\n.container-textarea {\r\n  margin: 0px 40px 40px 40px;\r\n}\r\n\r\n.info-icon {\r\n  margin-left: 5px;\r\n  color: #4285f4;\r\n  cursor: pointer;\r\n}\r\n\r\nion-checkbox {\r\n  --size: 18px;\r\n  --checkbox-background-checked: #4285f4;\r\n  margin-left: 3px;\r\n}\r\n\r\nion-checkbox::part(container) {\r\n  border-radius: 6px;\r\n  border: 2px solid #4285f4;\r\n}\r\n\r\n.anonymous-label {\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.checkbox-container {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 6px;\r\n}\r\n\r\n.icon-link ion-icon {\r\n  margin-left: 4px;\r\n  font-size: 22px;\r\n}\r\n\r\nion-input {\r\n  max-width: 65%;\r\n}\r\n\r\n.input-link {\r\n  max-width: none\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
